export function createProdutividadeViewModel() {
  return [
    { id: "prod-leads-criadas", label: "Leads criadas", value: "24", hint: "Hoje" },
    { id: "prod-leads-atualizadas", label: "Leads atualizadas", value: "37", hint: "Hoje" },
    { id: "prod-conversao", label: "Conversao", value: "18%", hint: "Placeholder" },
    { id: "prod-tempo-medio", label: "Tempo medio", value: "14m", hint: "Placeholder" }
  ];
}
